const PlayDesktop = () => (
  <svg fill="none" height="167" viewBox="0 0 167 167" width="167" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="84" cy="84" fill="black" fill-opacity="0.4" rx="81" ry="80" />
    <path className="group-hover:fill-white transition-all" d="M116 84L68 111.713L68 56.2872L116 84Z" fill="#EEDFAF" />
    <circle cx="83.5" cy="83.5" r="76.5" stroke="url(#paint0_linear_7647_720)" stroke-width="14" />
    <circle cx="83.5" cy="83.5" r="68" stroke="url(#paint1_linear_7647_720)" stroke-width="3" />
    <defs>
      <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_7647_720" x1="84" x2="84" y1="14" y2="153">
        <stop stop-color="#FFD789" />
        <stop offset="0.25" stop-color="#956C42" />
        <stop offset="0.5" stop-color="#AD7C3F" />
        <stop offset="0.75" stop-color="#6C4B2B" />
        <stop offset="1" stop-color="#A97948" />
      </linearGradient>
      <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_7647_720" x1="83.5" x2="83.5" y1="14" y2="153">
        <stop stop-color="#8E663D" />
        <stop offset="1" stop-color="#EBC067" />
      </linearGradient>
    </defs>
  </svg>
);

export default PlayDesktop;
